import { Box, Button, Card, Divider, Grid, IconButton, Paper, TextField, Typography } from "@mui/material";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ImagePlaceHolder from "../../../../assets/images/image-placeholder.jpg";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";


import SuggestionSimulatorComponent from "./SuggestionSimulatorComponent";
import { useState } from "react";
import MediaWithDynamicURL from "./MediaWithDynamicURL";
import { DYNAMIC_URL_REGEX } from "../../../../constants";
import { MediaHandler } from "./MediaHandler";

export default function RichCardCarouselDetailsComponent({ richCardCarouselDetails }) {

    const [index, setIndex] = useState(0);

    // Helper function to get media height
    const getMediaHeight = () => {
        return richCardCarouselDetails.mediaHeight === "MEDIUM_HEIGHT" ? "150px" : "100px";
    };

    // Helper function to get card width
    const getCardWidth = () => {
        return richCardCarouselDetails.cardWidth === "MEDIUM_WIDTH" ? "70%" : "50%";
    };

    // Helper function to truncate text
    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    // Reusable Card Component
    const CarouselCard = ({ cardData, showLeftNav, showRightNav }) => (
        <Grid
            item
            sx={{
                minWidth: getCardWidth(),
                maxWidth: getCardWidth(),
            }}
            minHeight="30vh"
            maxHeight="40vh"
            padding={2}
        >
            {/* Left Navigation Button */}
            {showLeftNav && (
                <Grid
                    item
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    style={{ position: "absolute", top: "37%", left: "3%" }}
                >
                    <Box
                        sx={{
                            zIndex: 1,
                            height: "1.5rem",
                            minWidth: "1.5rem",
                            maxWidth: "1.5rem",
                            backgroundColor: "white",
                            border: "3px solid white",
                            borderRadius: "50px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                        onClick={() => setIndex(index - 1)}
                    >
                        <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                            <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"></path>
                        </svg>
                    </Box>
                </Grid>
            )}

            {/* Right Navigation Button */}
            {showRightNav && (
                <Grid
                    item
                    display="flex"
                    justifyContent="end"
                    alignItems="center"
                    style={{ position: "absolute", top: "37%", right: "3%" }}
                >
                    <Box
                        sx={{
                            zIndex: 1,
                            height: "1.5rem",
                            minWidth: "1.5rem",
                            maxWidth: "1.5rem",
                            backgroundColor: "white",
                            border: "3px solid white",
                            borderRadius: "50px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                        onClick={() => setIndex(index + 1)}
                    >
                        <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                            <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
                        </svg>
                    </Box>
                </Grid>
            )}

            {/* Card Content */}
            <Card sx={{ height: "100%", backgroundColor: "#e9e6e6", borderRadius: "10px" }}>
                {/* Media Section */}
                <Box>
                    <MediaHandler
                        media={cardData.cardMedia}
                        thumbnail={cardData.cardThumbnail}
                        height={getMediaHeight()}
                        width="100%"
                        iconPosition="center"
                    />
                </Box>

                {/* Text Content Section */}
                <Box padding={1}>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                    >
                        {truncateText(cardData.cardTitle, 38)}
                    </Typography>

                    <TextField
                        multiline
                        size="small"
                        fullWidth
                        label={null}
                        value={truncateText(cardData.cardDescription, 25)}
                        variant="standard"
                        InputProps={{
                            readOnly: true,
                            disableUnderline: true,
                        }}
                        sx={{
                            pointerEvents: "none",
                            backgroundColor: "transparent",
                            "& .MuiInputBase-root": {
                                border: "none",
                            },
                            "& .MuiInputBase-inputMultiline": {
                                padding: 0,
                            },
                            margin: 1,
                            fontSize: "0.875rem",
                            color: "black",
                        }}
                    />

                    {/* Suggestions Section */}
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        flexDirection: "column"
                    }}>
                        {cardData.suggestionsList?.map((suggestions, suggestionIndex) => (
                            <Box key={suggestionIndex} marginTop={1}>
                                <SuggestionSimulatorComponent suggestion={suggestions} />
                                <Divider />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Card>
        </Grid>
    );

    return (
        <div style={{ minWidth: "100%", display: "flex" }}>
            {/* Current Card */}
            {richCardCarouselDetails.cardsList[index] && (
                <CarouselCard
                    cardData={richCardCarouselDetails.cardsList[index]}
                    showLeftNav={index > 0}
                    showRightNav={false}
                />
            )}

            {/* Next Card Preview */}
            {richCardCarouselDetails.cardsList[index + 1] && (
                <CarouselCard
                    cardData={richCardCarouselDetails.cardsList[index + 1]}
                    showLeftNav={false}
                    showRightNav={true}
                />
            )}
        </div>
    );
}

